export default __webpack_public_path__ + "static/media/5.ad606e3f.jpg";